import dashboardSensorsQuery from '../../../Dashboard/Content/SensorsQuery/lib/query'

export default ({ query, variables }) => [
  { query, variables },
  { query: dashboardSensorsQuery, variables: { filters: [] } },
]
